import type { DisciplineAllocationResults } from '../model/interfaces'
import type { ApiResponse } from '@shared/api'

import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface DisciplineScheduleAllocationResultsApiOptions {
  disciplineId: string | number
  activationRunId: number
}

/** `GET /admin-api/disciplines/{discipline}/schedule/allocation-results/{activationRun}` — the candidate tutors of a
 *  run, best availability first. */
export const useDisciplineScheduleAllocationResultsApi = async (
  options: DisciplineScheduleAllocationResultsApiOptions,
): Promise<DisciplineAllocationResults | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.disciplines.api.schedule.allocation-results', {
    discipline_id: options.disciplineId,
    activation_run_id: options.activationRunId,
  })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.get<ApiResponse>(url)

    return data.data ?? null
  } catch {
    toast.error({ title: 'Error!', description: 'Tutor availability request failed!' })
    return null
  }
}
